/**
 * i18n middleware to check for specific key patterns
 * When using t('example_key'), it will check if 'example_key_2025' exists
 * If it exists, it will return the value of 'example_key_2025'
 * Otherwise, it will return the value of 'example_key'
 * The year (2025) is retrieved from localStorage
 */

import { is1593 } from './func';

const YearSpecificTranslationPlugin = {
  name: 'yearSpecificTranslation',
  type: 'postProcessor',

  process(value, key, options, translator) {
    try {
      const template = Number(localStorage.getItem('template'));
      const year = is1593(template) ? 2025 : 2019;
      if (!key[0].includes('projectProposal') && !key[0].includes('errorMessage') && year < 2025) {
        return value;
      }
      const yearSpecificKey = `${key}_${year}`;
      const hasYearSpecificValue = translator.exists(yearSpecificKey, options);
      if (hasYearSpecificValue) {
        const yearSpecificValue = translator.translate(yearSpecificKey, {
          ...options,
          postProcess: [],
        });
        return yearSpecificValue;
      }

      return value;
    } catch (error) {
      return value;
    }
  },
};

export default YearSpecificTranslationPlugin;
